module.exports = __webpack_public_path__ + "static/dance-603d83b2c1abfde72c1e7d406f56c546.png";